var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _g, _g2, _g3, _path20, _g4, _path21, _g5, _path22, _g6, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _g7, _g8, _g9, _path30, _g0, _path31, _g1, _path32, _g10, _path33;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContigo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 121.794,
    height: 40,
    viewBox: "0 0 121.794 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_710",
    "data-name": "Rect\\xE1ngulo 710",
    width: 0.944,
    height: 0.864,
    transform: "translate(258.431 19.219)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_711",
    "data-name": "Rect\\xE1ngulo 711",
    width: 0.945,
    height: 0.828,
    transform: "translate(262.766 19.259)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_712",
    "data-name": "Rect\\xE1ngulo 712",
    width: 6.549,
    height: 6.377,
    transform: "translate(264.816 14.493)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_713",
    "data-name": "Rect\\xE1ngulo 713",
    width: 6.55,
    height: 6.377,
    transform: "translate(272.502 23.405)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_714",
    "data-name": "Rect\\xE1ngulo 714",
    width: 7.807,
    height: 4.995,
    transform: "translate(273.877 14.927)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_715",
    "data-name": "Rect\\xE1ngulo 715",
    width: 7.803,
    height: 5.003,
    transform: "translate(263.072 23.779)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_716",
    "data-name": "Rect\\xE1ngulo 716",
    width: 0.944,
    height: 0.872,
    transform: "translate(257.382 18.178)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_717",
    "data-name": "Rect\\xE1ngulo 717",
    width: 0.944,
    height: 0.828,
    transform: "translate(261.734 18.218)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_718",
    "data-name": "Rect\\xE1ngulo 718",
    width: 6.558,
    height: 6.385,
    transform: "translate(263.775 13.452)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_719",
    "data-name": "Rect\\xE1ngulo 719",
    width: 6.553,
    height: 6.385,
    transform: "translate(271.466 22.365)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_720",
    "data-name": "Rect\\xE1ngulo 720",
    width: 7.807,
    height: 5.003,
    transform: "translate(272.84 13.886)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_721",
    "data-name": "Rect\\xE1ngulo 721",
    width: 7.807,
    height: 4.995,
    transform: "translate(262.035 22.746)",
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1633",
    "data-name": "Grupo 1633",
    transform: "translate(-270.878 -2389)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_933",
    "data-name": "Trazado 933",
    d: "M359.259,9.571a13.316,13.316,0,0,0-4.539.773,6.128,6.128,0,0,0-2.276-.439h-3.03a6.2,6.2,0,0,0-.684.037,10.165,10.165,0,0,0-1.373-.275,6.143,6.143,0,0,0-5.838-4.2h-3.1c-.149,0-.3.009-.442.02-.162-.013-.323-.028-.486-.028H325.98a6.165,6.165,0,0,0-5.813,4.124c-.18-.009-.361-.013-.544-.013a11.084,11.084,0,0,0-2.975.407,6.184,6.184,0,0,0-.926-.069h-2.431a6.16,6.16,0,0,0-2.213.415,12.826,12.826,0,0,0-4.4-.753c-.04,0-.079,0-.118,0A6.14,6.14,0,0,0,303.6,6.682a16.689,16.689,0,0,0-6.9-1.551,13.668,13.668,0,0,0-8.2,2.555,6.16,6.16,0,0,0-1.688-.375l.01-.055a6.157,6.157,0,0,0,.091-1.352c0-.011,0-.022,0-.033a6.081,6.081,0,0,0-.062-.633c-.011-.072-.031-.142-.044-.214-.028-.147-.054-.3-.092-.441-.027-.1-.065-.2-.1-.3s-.067-.226-.11-.337-.105-.237-.159-.355c-.039-.085-.072-.173-.115-.256-.087-.168-.186-.33-.288-.489-.019-.03-.034-.062-.054-.092a6.271,6.271,0,0,0-.4-.536l-.007-.009h0A6.162,6.162,0,0,0,282.746.333l-.008,0h0a6.135,6.135,0,0,0-1.99-.33h-5.263A6.142,6.142,0,0,0,273.5.333a6.781,6.781,0,0,0-2-.333h-5.259a6.166,6.166,0,0,0-6.07,5.076l-.4,2.209h-1.59a6.167,6.167,0,0,0-6.072,5.089l-.683,3.846c-.033.13-.063.261-.087.394l-.021.109c-.03.164-.051.328-.068.491l-.029.163a6.146,6.146,0,0,0-.024,2.011,6.156,6.156,0,0,0-.673,1.9l-.88,5a6.162,6.162,0,0,0,5.469,7.2c-.005.084,0,.168,0,.253,0,.116-.009.232-.005.348v.006c.005.11.021.219.032.329s.016.223.032.333.046.223.069.334.039.215.067.321.07.219.106.329.061.207.1.308.093.209.14.314.084.2.134.3.114.195.171.292.109.2.171.29.14.189.21.282.125.178.2.261l0,0,0,0c.079.094.166.178.25.267s.138.156.213.228c.09.086.188.162.282.243.077.065.15.135.23.2.1.076.206.142.309.212.082.055.16.116.245.167h0c.024.015.05.026.075.04.088.052.179.1.269.145s.16.091.243.13c.124.058.252.1.379.153.081.031.16.069.242.1.136.046.276.08.415.117.077.021.153.048.231.065.146.033.3.052.444.074.074.011.147.029.222.037a6.158,6.158,0,0,0,.68.038h5.264c.186,0,.371-.009.554-.025.079-.007.156-.021.234-.031.1-.014.206-.024.307-.042s.172-.038.258-.058.181-.037.269-.061.191-.06.286-.091l.08-.025a6.189,6.189,0,0,0,2,.333h5.268c.187,0,.372-.009.555-.025.049,0,.1-.014.144-.019.134-.016.267-.03.4-.054.079-.014.155-.035.233-.053.1-.021.2-.04.294-.066.122-.033.24-.074.358-.115.05-.017.1-.03.152-.049.106-.038.208-.085.311-.129.06-.026.121-.049.18-.076.119-.056.233-.119.347-.182.04-.022.083-.041.122-.064.14-.082.276-.17.409-.262.012-.008.024-.014.036-.023.132-.092.258-.19.382-.292l.037-.028c.106-.09.207-.185.308-.281.026-.026.055-.049.081-.075.107-.1.207-.217.306-.33.017-.02.036-.038.053-.057.089-.106.172-.217.254-.328.023-.031.049-.06.071-.091.079-.111.151-.227.222-.343.022-.035.046-.068.067-.1.057-.1.108-.2.16-.3.03-.058.063-.113.091-.172.041-.086.075-.177.113-.266s.068-.153.1-.232.053-.164.079-.245.063-.182.089-.276c.019-.071.032-.145.049-.217.025-.107.053-.213.073-.323l.251-1.4h1.759a6.163,6.163,0,0,0,4.923-2.46A13.749,13.749,0,0,0,296.7,33.4a16.362,16.362,0,0,0,5.254-.892,13.158,13.158,0,0,0,9.127.124,6.143,6.143,0,0,0,2.21.414h3.029a6.144,6.144,0,0,0,2.123-.375,6.152,6.152,0,0,0,2.145.383h3.03a6.185,6.185,0,0,0,1.676-.236,6.168,6.168,0,0,0,1.63.228h3.118a6.149,6.149,0,0,0,2.566-.558,6.166,6.166,0,0,0,2.562.562h1.254A6.138,6.138,0,0,0,338.77,35.7a14.561,14.561,0,0,0,7.679,2.133c4.454,0,7.956-1.732,10.035-4.718a13.89,13.89,0,0,0,2.775.278c7.116,0,12.086-4.9,12.086-11.91s-4.97-11.909-12.086-11.909",
    transform: "translate(21.327 2389)",
    fill: "#001850"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_934",
    "data-name": "Trazado 934",
    d: "M297.733,12.765a10.515,10.515,0,0,1,4.332.988l-.828,2.468a7.963,7.963,0,0,0-3.5-.784c-2.712,0-4.171,2.13-4.171,5.3s1.463,5.3,4.171,5.3a7.932,7.932,0,0,0,3.5-.792l.828,2.468a10.471,10.471,0,0,1-4.332.988c-4.8,0-7.426-3.206-7.426-7.96s2.632-7.968,7.426-7.968",
    transform: "translate(21.327 2389)",
    fill: "#001850"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_935",
    "data-name": "Trazado 935",
    d: "M307.718,28.693a5.412,5.412,0,0,1-5.7-5.742,5.706,5.706,0,1,1,11.412,0,5.387,5.387,0,0,1-5.714,5.742m0-2.491c1.587,0,2.62-1.073,2.62-3.255s-1.033-3.254-2.62-3.254c-1.551,0-2.6,1.076-2.6,3.254s1.053,3.255,2.6,3.255",
    transform: "translate(21.327 2389)",
    fill: "#001850"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_936",
    "data-name": "Trazado 936",
    d: "M316.755,17.543l.41,1.053h.044a5.052,5.052,0,0,1,3.456-1.391c2.531,0,3.994,1.728,3.994,4.332v6.819h-3.03v-6.51c0-1.414-.607-2.157-1.925-2.157a3.942,3.942,0,0,0-2.334.92v7.739h-3.03V17.543Z",
    transform: "translate(21.327 2389)",
    fill: "#001850"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_937",
    "data-name": "Trazado 937",
    d: "M338.537,13.1l-.563,2.6h-4.191l-2.692,12.649h-3.118l2.692-12.649h-4.2l.563-2.6Z",
    transform: "translate(21.327 2389)",
    fill: "#001850"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_938",
    "data-name": "Trazado 938",
    d: "M339.321,28.352H336.2L339.458,13.1h3.094Z",
    transform: "translate(21.327 2389)",
    fill: "#001850"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_939",
    "data-name": "Trazado 939",
    d: "M353.477,27.194c0,4.147-2.158,5.943-5.991,5.943a8.436,8.436,0,0,1-4.441-1.213l1.1-2.62a6.118,6.118,0,0,0,3.344.9c1.567,0,2.31-.607,2.31-2.246v-.587h-.044a4.346,4.346,0,0,1-2.853,1.053c-3.094,0-4.8-2.423-4.8-5.561s1.7-5.65,4.8-5.65a3.971,3.971,0,0,1,3.118,1.37h.044l.378-1.032h3.03v9.643ZM349.8,20.729a2.954,2.954,0,0,0-1.748-.579c-1.41,0-2.2.945-2.2,2.713,0,1.792.784,2.628,2.2,2.628A2.857,2.857,0,0,0,349.8,24.9Z",
    transform: "translate(21.327 2389)",
    fill: "#001850"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_940",
    "data-name": "Trazado 940",
    d: "M360.292,28.693c-3.994,0-5.963-2.6-5.963-5.742s1.973-5.742,5.963-5.742c4.062,0,5.927,2.6,5.927,5.742s-1.861,5.742-5.927,5.742m0-2.941c1.274,0,2.174-.784,2.174-2.805s-.9-2.8-2.174-2.8c-1.23,0-2.218.783-2.218,2.8s.988,2.805,2.218,2.805",
    transform: "translate(21.327 2389)",
    fill: "#001850"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_941",
    "data-name": "Trazado 941",
    d: "M296.7,11.733a10.515,10.515,0,0,1,4.332.988l-.828,2.468a7.964,7.964,0,0,0-3.5-.784c-2.712,0-4.171,2.13-4.171,5.3S293.992,25,296.7,25a7.932,7.932,0,0,0,3.5-.792l.828,2.468a10.471,10.471,0,0,1-4.332.988c-4.8,0-7.426-3.206-7.426-7.96s2.628-7.968,7.426-7.968",
    transform: "translate(21.327 2389)",
    fill: "#fff"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_942",
    "data-name": "Trazado 942",
    d: "M306.681,27.656a5.412,5.412,0,0,1-5.7-5.742,5.706,5.706,0,1,1,11.412,0,5.391,5.391,0,0,1-5.714,5.742m0-2.491c1.587,0,2.62-1.073,2.62-3.255s-1.033-3.254-2.62-3.254c-1.551,0-2.6,1.076-2.6,3.254s1.057,3.255,2.6,3.255",
    transform: "translate(21.327 2389)",
    fill: "#fff"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_943",
    "data-name": "Trazado 943",
    d: "M315.722,16.51l.41,1.053h.044a5.052,5.052,0,0,1,3.456-1.391c2.531,0,3.994,1.728,3.994,4.332v6.819H320.6v-6.51c0-1.414-.607-2.157-1.925-2.157a3.942,3.942,0,0,0-2.334.92v7.739h-3.03V16.51Z",
    transform: "translate(21.327 2389)",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_944",
    "data-name": "Trazado 944",
    d: "M337.5,12.062l-.563,2.6h-4.191l-2.692,12.649h-3.118l2.692-12.649h-4.2l.563-2.6Z",
    transform: "translate(21.327 2389)",
    fill: "#00b0f2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_945",
    "data-name": "Trazado 945",
    d: "M338.288,27.319H335.17l3.255-15.249h3.094Z",
    transform: "translate(21.327 2389)",
    fill: "#00b0f2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_946",
    "data-name": "Trazado 946",
    d: "M352.437,26.154c0,4.147-2.158,5.943-5.991,5.943a8.436,8.436,0,0,1-4.441-1.213l1.1-2.62a6.118,6.118,0,0,0,3.344.9c1.567,0,2.31-.607,2.31-2.246v-.579h-.044a4.346,4.346,0,0,1-2.853,1.053c-3.094,0-4.8-2.423-4.8-5.561s1.7-5.65,4.8-5.65a3.971,3.971,0,0,1,3.118,1.37h.044l.378-1.032h3.03v9.639h.008Zm-3.677-6.461a2.954,2.954,0,0,0-1.748-.579c-1.41,0-2.2.945-2.2,2.713,0,1.792.784,2.628,2.2,2.628a2.857,2.857,0,0,0,1.748-.587Z",
    transform: "translate(21.327 2389)",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_947",
    "data-name": "Trazado 947",
    d: "M359.255,27.656c-3.994,0-5.963-2.6-5.963-5.742s1.973-5.742,5.963-5.742c4.062,0,5.927,2.6,5.927,5.742s-1.865,5.742-5.927,5.742m0-2.937c1.274,0,2.174-.784,2.174-2.805s-.9-2.8-2.174-2.8c-1.23,0-2.218.783-2.218,2.8s.984,2.805,2.218,2.805",
    transform: "translate(21.327 2389)",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_948",
    "data-name": "Trazado 948",
    d: "M267.572,35.3h-5.264l4.967-27.661h5.263Z",
    transform: "translate(21.327 2389)",
    fill: "#001850"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_949",
    "data-name": "Trazado 949",
    d: "M276.818,35.3h-5.26l4.967-27.661h5.263Z",
    transform: "translate(21.327 2389)",
    fill: "#001850"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_950",
    "data-name": "Trazado 950",
    d: "M272.539,7.638l-1.977,11-.518,2.889-1.065,5.931-.526,2.941-.88,4.9h-5.264l1.052-5.862.37-2.058,1.23-6.859.353-1.969,1.961-10.913Z",
    transform: "translate(21.327 2389)",
    fill: "#001850"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_951",
    "data-name": "Trazado 951",
    d: "M281.789,7.638l-1.977,11-.518,2.889-1.065,5.931L277.7,30.4l-.879,4.9h-5.26l1.052-5.862.37-2.058,1.23-6.859.357-1.969,1.957-10.913Z",
    transform: "translate(21.327 2389)",
    fill: "#001850"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_952",
    "data-name": "Trazado 952",
    d: "M286.482,19.922H258.335l.88-4.995H287.37Z",
    transform: "translate(21.327 2389)",
    fill: "#001850"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_953",
    "data-name": "Trazado 953",
    d: "M284.907,28.826H256.76l.88-5h28.147Z",
    transform: "translate(21.327 2389)",
    fill: "#001850"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1568",
    "data-name": "Grupo 1568",
    transform: "translate(21.327 2389)",
    opacity: 0.5,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1567",
    "data-name": "Grupo 1567"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1566",
    "data-name": "Grupo 1566",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_954",
    "data-name": "Trazado 954",
    d: "M259.335,19.391a1.076,1.076,0,0,1-.892-.173l-.012.1a1.257,1.257,0,0,1,.607.763l.337-.715a.055.055,0,0,1-.04.024",
    fill: "#001850"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1571",
    "data-name": "Grupo 1571",
    transform: "translate(21.327 2389)",
    opacity: 0.5,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1570",
    "data-name": "Grupo 1570"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1569",
    "data-name": "Grupo 1569",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_955",
    "data-name": "Trazado 955",
    d: "M262.875,19.391l-.052-.02a.549.549,0,0,0-.056-.032l.317.747a1.205,1.205,0,0,1,.627-.771l-.012-.057a1,1,0,0,1-.824.133",
    fill: "#001850"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1574",
    "data-name": "Grupo 1574",
    transform: "translate(21.327 2389)",
    opacity: 0.5,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1573",
    "data-name": "Grupo 1573"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1572",
    "data-name": "Grupo 1572",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_956",
    "data-name": "Trazado 956",
    d: "M271.365,14.493l-.639,3.962-.482,2.415h-5.429l.5-2.491.622-3.886Z",
    fill: "#001850"
  }))))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_957",
    "data-name": "Trazado 957",
    d: "M271.944,19.922h-13.61l.88-4.995h13.614Z",
    transform: "translate(21.327 2389)",
    fill: "#001850"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1577",
    "data-name": "Grupo 1577",
    transform: "translate(21.327 2389)",
    opacity: 0.5,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1576",
    "data-name": "Grupo 1576"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1575",
    "data-name": "Grupo 1575",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_958",
    "data-name": "Trazado 958",
    d: "M279.052,23.405l-.639,3.966-.486,2.411H272.5l.5-2.495.618-3.882Z",
    fill: "#001850"
  }))))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_959",
    "data-name": "Trazado 959",
    d: "M284.907,28.826H271.8l.88-5h13.107Z",
    transform: "translate(21.327 2389)",
    fill: "#001850"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1580",
    "data-name": "Grupo 1580",
    transform: "translate(21.327 2389)",
    opacity: 0.5,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1579",
    "data-name": "Grupo 1579"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1578",
    "data-name": "Grupo 1578",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_960",
    "data-name": "Trazado 960",
    d: "M280.8,19.922h-6.927l.884-4.995h6.923Z",
    fill: "#001850"
  }))))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_961",
    "data-name": "Trazado 961",
    d: "M281.789,7.638l-1.977,11-.651,4.126H273.9l.671-4.215,1.957-10.913Z",
    transform: "translate(21.327 2389)",
    fill: "#001850"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1583",
    "data-name": "Grupo 1583",
    transform: "translate(21.327 2389)",
    opacity: 0.5,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1582",
    "data-name": "Grupo 1582"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1581",
    "data-name": "Grupo 1581",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_962",
    "data-name": "Trazado 962",
    d: "M270,28.782h-6.923l.88-5h6.923Z",
    fill: "#001850"
  }))))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_963",
    "data-name": "Trazado 963",
    d: "M269.858,22.682,267.572,35.3h-5.264l2.29-12.617Z",
    transform: "translate(21.327 2389)",
    fill: "#001850"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_964",
    "data-name": "Trazado 964",
    d: "M266.531,34.258h-5.264L266.238,6.6H271.5Z",
    transform: "translate(21.327 2389)",
    fill: "#ff5575"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_965",
    "data-name": "Trazado 965",
    d: "M275.785,34.258h-5.268L275.484,6.6h5.263Z",
    transform: "translate(21.327 2389)",
    fill: "#ff5575"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_966",
    "data-name": "Trazado 966",
    d: "M271.5,6.6l-1.977,11-.514,2.9-1.065,5.931-.53,2.941-.88,4.89h-5.264L262.32,28.4l.37-2.062,1.234-6.859.353-1.965L266.238,6.6Z",
    transform: "translate(21.327 2389)",
    fill: "#00b0f2"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_967",
    "data-name": "Trazado 967",
    d: "M280.748,6.6l-1.969,11-.526,2.9-1.065,5.931-.526,2.941-.876,4.89h-5.268l1.056-5.858.37-2.062,1.234-6.859.349-1.965L275.484,6.6Z",
    transform: "translate(21.327 2389)",
    fill: "#00b0f2"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_968",
    "data-name": "Trazado 968",
    d: "M285.449,18.889H257.294l.888-5h28.147Z",
    transform: "translate(21.327 2389)",
    fill: "#00b0f2"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_969",
    "data-name": "Trazado 969",
    d: "M283.866,27.785H255.719l.88-4.995h28.155Z",
    transform: "translate(21.327 2389)",
    fill: "#00b0f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1586",
    "data-name": "Grupo 1586",
    transform: "translate(21.327 2389)",
    opacity: 0.5,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1585",
    "data-name": "Grupo 1585"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1584",
    "data-name": "Grupo 1584",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_970",
    "data-name": "Trazado 970",
    d: "M258.294,18.351a1.076,1.076,0,0,1-.892-.173l-.02.109a1.257,1.257,0,0,1,.607.763l.337-.715c0,.012-.016.016-.032.016",
    fill: "#ffccd7"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1589",
    "data-name": "Grupo 1589",
    transform: "translate(21.327 2389)",
    opacity: 0.5,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1588",
    "data-name": "Grupo 1588"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1587",
    "data-name": "Grupo 1587",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_971",
    "data-name": "Trazado 971",
    d: "M261.842,18.351l-.052-.02a.549.549,0,0,0-.056-.032l.317.747a1.205,1.205,0,0,1,.627-.771l-.012-.057a1.014,1.014,0,0,1-.824.133",
    fill: "#ffccd7"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1592",
    "data-name": "Grupo 1592",
    transform: "translate(21.327 2389)",
    opacity: 0.5,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1591",
    "data-name": "Grupo 1591"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1590",
    "data-name": "Grupo 1590",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_972",
    "data-name": "Trazado 972",
    d: "M270.333,13.452l-.639,3.97-.486,2.415h-5.433l.5-2.5.618-3.886Z",
    fill: "#001850"
  }))))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_973",
    "data-name": "Trazado 973",
    d: "M270.907,18.889H257.293l.888-5h13.606Z",
    transform: "translate(21.327 2389)",
    fill: "#00b0f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1595",
    "data-name": "Grupo 1595",
    transform: "translate(21.327 2389)",
    opacity: 0.5,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1594",
    "data-name": "Grupo 1594"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1593",
    "data-name": "Grupo 1593",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_974",
    "data-name": "Trazado 974",
    d: "M278.019,22.365l-.639,3.966-.486,2.419h-5.429l.5-2.5.618-3.89Z",
    fill: "#001850"
  }))))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_975",
    "data-name": "Trazado 975",
    d: "M283.866,27.785H270.759l.88-4.995h13.115Z",
    transform: "translate(21.327 2389)",
    fill: "#00b0f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1598",
    "data-name": "Grupo 1598",
    transform: "translate(21.327 2389)",
    opacity: 0.5,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1597",
    "data-name": "Grupo 1597"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1596",
    "data-name": "Grupo 1596",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_976",
    "data-name": "Trazado 976",
    d: "M279.767,18.889H272.84l.88-5h6.927Z",
    fill: "#001850"
  }))))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_977",
    "data-name": "Trazado 977",
    d: "M280.748,6.6l-1.969,11-.659,4.134h-5.264l.671-4.219L275.484,6.6Z",
    transform: "translate(21.327 2389)",
    fill: "#00b0f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1601",
    "data-name": "Grupo 1601",
    transform: "translate(21.327 2389)",
    opacity: 0.5,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1600",
    "data-name": "Grupo 1600"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1599",
    "data-name": "Grupo 1599",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_978",
    "data-name": "Trazado 978",
    d: "M268.962,27.741h-6.927l.88-5h6.927Z",
    fill: "#001850"
  }))))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_979",
    "data-name": "Trazado 979",
    d: "M268.826,21.641l-2.294,12.617h-5.264l2.3-12.617Z",
    transform: "translate(21.327 2389)",
    fill: "#00b0f2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContigo);
export default __webpack_public_path__ + "static/media/contigo.14e8202fa574a8cbc5f575efd3406940.svg";
export { ForwardRef as ReactComponent };